import Layout from './NoSidebar';
export default Layout;

export const componentName = 'NoSidebar';
